import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Question } from '@empathy/survey-core';

@Component({
  selector: 'empathy-nps-question-view',
  templateUrl: 'nps-question-view.component.html',
  styleUrls: ['./nps-question-view.component.scss', './_nps-question-view-theme.component.scss']
})
export class NPSQuestionViewComponent {
  @Input() question: Question;
  @Input() questionCtrl: FormControl;

  onRate(scale: number): void {
    this.questionCtrl.setValue(scale);
  }
}
